/* Jquery */
var $ = require("jquery");

import timepicker from "timepicker";

function timePicker () {
    $('.timepicker').timepicker({
        minTime: '07:00',
        maxTime: '23:30',
        listWidth: 1,
        timeFormat: 'H:i',
    });
}

export default timePicker;

//////////////////////////////////////////////////

